import { useRouteError } from 'react-router';

import { useNetworkStatus } from 'src/hooks/useNetworkStatus';

import OfflinePage from 'src/pages/error/OfflinePage';
import ChunkLoadErrorPage from 'src/pages/error/ChunkLoadErrorPage';
import InternalServerErrorPage from 'src/pages/error/InternalServerErrorPage';

function ErrorBoundary() {
  const { isOnline } = useNetworkStatus();
  const error = useRouteError();

  if (!isOnline) {
    return <OfflinePage />;
  }

  if (
    error instanceof Error &&
    error.message.includes('Failed to fetch dynamically imported module')
  ) {
    return <ChunkLoadErrorPage />;
  }

  return <InternalServerErrorPage />;
}

export default ErrorBoundary;
